import Api from '@/services/Api'

export default {
  getPackagings() {
    return Api().get("/packagings");
  },
  createPackaging(data) {
    return Api().post("/packagings", data);
  },
  deletePackaging(id) {
    return Api().delete(`/packagings/${id}`);
  },
  updatePackaging(id, data) {
    return Api().put(`/packagings/${id}`, data);
  },
  updatePackagingStock(sku, newStock) {
    return Api().put(`/packagings/stock/${sku}`, { newStock: newStock });
  },
  getPackagingLogs(sku) {
    return Api().get(`/packagings/logs/${sku}`);
  },
  getUniqueSkus() {
    return Api().get('/packagings/skus');
  },
  getPackagingSelection(orderId) {
    return Api().get(`/packagings/selection?orderId=${orderId}`);
  },
  uploadImage(packagingId, formData) {
    return Api().post(`/packagings/upload-image/${packagingId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
}